import type { ConfirmationModalContent, ConfirmationModalSeverity } from '../../../components/_components';
import type { ConsentActionType } from '../types';

export const consentConfirmationContent: Record<ConsentActionType, ConfirmationModalContent> = {
  ACCEPTED: {
    title: 'Provide AI Data Processing Consent',
    message:
      'Are you sure you want to provide consent for AI data processing? AI-powered features such as AI Insights and AI Chatbot will use relevant business data to generate insights and assistance.',
    confirmLabel: 'Provide Consent',
  },
  REVOKED: {
    title: 'Withdraw AI Data Processing Consent',
    message:
      'Are you sure you want to withdraw your consent for AI data processing? After withdrawal, AI-powered features such as AI Insights and AI Chatbot will no longer be available until you provide consent again.',
    confirmLabel: 'Withdraw Consent',
  },
};

export const consentConfirmationSeverity: Record<ConsentActionType, ConfirmationModalSeverity> = {
  ACCEPTED: 'primary',
  REVOKED: 'error',
};
